import React from 'react';
import Map from './components/Map/Map';
import { Protocol } from "pmtiles";
import maplibregl from 'maplibre-gl';
import './App.css';
import 'maplibre-gl/dist/maplibre-gl.css';

import { CatalogContextProvider } from './components/CatalogContext'; 
import { UserContextProvider } from './components/UserContext'; 
import { MapContextProvider } from './components/MapContext'; 
    
const App = () => {
 
  let protocol = new Protocol();
  maplibregl.addProtocol("pmtiles", protocol.tile);

  return (
    <UserContextProvider>
      <CatalogContextProvider>
        <div className="App">
          <MapContextProvider>
            <Map/>
          </MapContextProvider>
      </div>
      </CatalogContextProvider>
    </UserContextProvider>
    )
}

export default App;

